module.exports = __webpack_public_path__ + "img/yishi4.0b83705e.jpg";